import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

export function useDraftTopic() {
  return useMutation({
    mutationFn: async ({ parentId, topicHint }) => {
      const { data } = await apiClient.post(`/conversations/${parentId}/topics/draft`, {
        topic_hint: topicHint,
      });
      return data;
    },
  });
}

export function useCreateTopic(projectId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ parentId, title, brief }) => {
      const { data } = await apiClient.post(`/conversations/${parentId}/topics`, { title, brief });
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["conversations", projectId] });
    },
  });
}
